{
	"title": "Mot de passe oublié ?",
	"subtitle": "Veuillez entrer l'adresse e-mail associée à votre compte.",
	"description": "Nous vous enverrons un lien pour réinitialiser votre mot de passe",
	"labels": {
		"company": "Entreprise",
		"email": "Adresse e-mail"
	},
	"fields": {
		"organization": {
			"placeholder": "Entrez l'entreprise",
			"required": "L'entreprise est requise"
		},
		"email": {
			"placeholder": "Entrez votre adresse e-mail",
			"required": "L'adresse e-mail est requise",
			"invalid": "Adresse e-mail invalide"
		}
	},
	"submit": "Envoyer",
	"submitWait": "Re-envoyer dans {{time}}",
	"back": "Retour",
	"successModal": {
		"title": "Demande envoyée !",
		"subtitle": "Si les données fournies sont correctes, nous vous enverrons un lien de réinitialisation à l'adresse e-mail enregistrée.",
		"btnTitle": "Compris"
	}
}
